import { panelTypes } from '../../common/panel/constants'
import { OverdueSocialInsurance } from './overdueSocialInsurance'
import { OverdueTaxDebt } from './overdueTaxDebt'

export const HIGHLIGHT_KEYS = {
  COMPANY_FILINGS: 'COMPANY_FILINGS',
  INVOICE_ENFORCEMENT: 'invoice_Enforment',
  OVERDUE_TAX_DEBT: 'overdue_Tax_Debt',
  OVERDUE_SOCIAL_INSURANCE: 'overdue_Social_Insurance',
}

export const PANEL_ID = {
  OVERDUE_TAX_DEBT: 'OVERDUE_TAX_DEBT',
  OVERDUE_SOCIAL_INSURANCE: 'OVERDUE_SOCIAL_INSURANCE',
}

export const PANEL_DATA = [
  {
    id: PANEL_ID.OVERDUE_TAX_DEBT,
    type: panelTypes.FULL_SIZE,
    label: 'filingStatus.OVERDUE_TAX_DEBT',
    component: OverdueTaxDebt,
  },
  {
    id: PANEL_ID.OVERDUE_SOCIAL_INSURANCE,
    type: panelTypes.FULL_SIZE,
    label: 'filingStatus.OVERDUE_SOCIAL_INSURANCE',
    component: OverdueSocialInsurance,
  },
]

export const OVERDUE_TAX_DEBT_TABLES = {
  OVERDUE_TAX_DEBT_HISTORY: 'OVERDUE_TAX_DEBT_HISTORY',
  INVOICE_ENFORCEMENT_HISTORY: 'INVOICE_ENFORCEMENT_HISTORY',
}

export const OVERDUE_SOCIAL_INSURANCE_TABLE = {
  PUBLICATION_DATE: 'publicDateId',
  AMOUNT: 'totalValue',
  OUTSTANDING_MONTHS: 'outstandingMonths',
  DEPARTMENT: 'organizationName',
}

export const TAX_ENFORCEMENT_TABLE = {
  PUBLICATION_DATE: 'publicDateId',
  AMOUNT: 'totalValue',
  DEPARTMENT: 'organizationName',
}

export const TAX_ENFORCEMENT_HISTORY_TABLE = {
  PUBLICATION_DATE: 'publicDateId',
  AMOUNT: 'totalValue',
  DEPARTMENT: 'organizationName',
  ENFORCEMENT_TYPE: 'enforcementTypeName',
}

export const getThStyle = (colId) => {
  switch (colId) {
    case 'publicDateId':
      return { width: 100 }
    case 'totalValue':
      return { width: 150 }
    case 'outstandingMonths':
      return { width: 200 }
    default:
      return {}
  }
}
